import * as React from 'react'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'

export const Benefits = () => {
  return (
    <div>
      <Headline>
        Ihre Vorteile bei <CompanyName>implacheck®</CompanyName>
      </Headline>
      <BenefitsList>
        <BenefitItem>100% Transparenz für Ihr bestes Ergebnis</BenefitItem>
        <BenefitItem>ausschließlich zertifizierte Implantat-Spezialisten</BenefitItem>
        <BenefitItem>höchste Qualitätsstandards durch erfahrene Behandler</BenefitItem>
        <BenefitItem>einfache Terminvereinbarung - online und per Telefon</BenefitItem>
        <BenefitItem>ohne Anmeldung und unverbindlich</BenefitItem>
      </BenefitsList>
    </div>
  )
}

const Headline = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  @media (max-width: 950px) {
    margin: 0 20px 20px 20px;
  }
  @media print { 
  display: none;
  }
`

const CompanyName = styled.span`
  color: ${(props) => props.theme.greenColor};
`

const BenefitsList = styled.ul`
  list-style: none;
  @media (max-width: 950px) {
    margin: 0 20px;
  }
  @media print { 
  display: none;
  }
`

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 25px;
  font-size: 14px;
  &:before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    flex: 0 0 20px;
    background: url(${Utils.getAssetPath('/assets/calculator/result/check.svg')}) no-repeat center center;
    background-size: contain;
  }
`
